import { TrendingUp, TrendingDown, Minus, Brain, Hammer, HeartHandshake } from "lucide-react";

const META = { smart: { icon: Brain, label: "Pintar" }, skill: { icon: Hammer, label: "Terampil" }, attitude: { icon: HeartHandshake, label: "Sikap" } };
const TONE = { up: "text-emerald-600 bg-emerald-50", down: "text-red-600 bg-red-50", flat: "text-slate-400 bg-slate-50" };

// Maskot reaktif: lebih banyak panah naik → "Bagus!", lebih banyak turun → "Coba Lagi!"
export function growthMascot(tracks) {
  if (!tracks) return null;
  const ups = Object.values(tracks).filter((t) => t.trend === "up").length;
  const downs = Object.values(tracks).filter((t) => t.trend === "down").length;
  if (ups > downs) return { img: "bagus", label: "Bagus!" };
  if (downs > ups) return { img: "cobalagi", label: "Coba lagi!" };
  return null;
}

export function GrowthMascot({ tracks, size = 28, testId = "growth-mascot" }) {
  const m = growthMascot(tracks);
  if (!m) return null;
  return <img src={`/mascot/${m.img}.png`} alt={m.label} title={m.label} data-testid={testId} data-mood={m.img} style={{ height: size, width: size }} className="object-contain shrink-0 drop-shadow oreo-dance-slow" />;
}

export function GrowthArrows({ tracks, size = "sm", testId, mascot = false }) {
  if (!tracks) return <span className="text-[10px] text-slate-300">…</span>;
  return (
    <span className="inline-flex items-center gap-1" data-testid={testId}>
      {mascot && <GrowthMascot tracks={tracks} size={size === "sm" ? 26 : 40} />}
      {Object.entries(META).map(([k, M]) => {
        const t = tracks[k] || {}; const Arrow = t.trend === "up" ? TrendingUp : t.trend === "down" ? TrendingDown : Minus;
        return <span key={k} title={`${M.label}: ${t.last ?? "-"} (${t.delta == null ? "belum ada data" : `${t.delta > 0 ? "+" : ""}${t.delta}`})`} data-testid={`growth-arrow-${k}`}
          className={`inline-flex items-center gap-0.5 rounded-full px-1.5 py-0.5 ${size === "sm" ? "text-[10px]" : "text-xs"} font-semibold ${TONE[t.trend || "flat"]}`}><M.icon className="h-3 w-3" /><Arrow className="h-3 w-3" />{t.delta != null && size !== "sm" ? `${t.delta > 0 ? "+" : ""}${t.delta}` : ""}</span>;
      })}
    </span>
  );
}
